import axios from 'axios'

export default {
  getForRole (params, callback, errorCallback) {
    axios
      .get('/api/bulletin_boards.json', { params: params })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error)) )
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/bulletin_boards.json`, {
        bulletin_board: params
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

  delete (id, callback, errorCallback) {
    axios
      .delete(`/api/bulletin_boards/${ id }.json`)
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  }
}
